<template>
  <div>
    <div class="d-flex justify-center">
      <BodyTalkLogo></BodyTalkLogo>
    </div>
    <v-card class="pa-8 my-5" flat>
      <div class="d-flex justify-space-between align-center">
        <div class="font-24"><b> [name_survey]</b></div>
        <v-img
          src="../../../src/assets/images/clipboard.png"
          max-width="45"
        ></v-img>
      </div>
      <div>
        <span class="grey--text font-14">
          [message_mail] Lorem ipsum dolor sit amet, consectetur adipiscing
          elit. Amet, nibh at cras sit tellus, velit fringilla. Lacus sed eu
          nisl, nec quam quisque. Malesuada proin turpis.
        </span>
      </div>
      <v-btn color="primary" block class="my-6 py-6" depressed @click="close()">
        APPLICAR
      </v-btn>
      <v-divider class="divider"></v-divider>
      <div class="font-24">Any questions about?</div>
      <span class="primary--text " style="cursor:pointer">Get in touch with our support</span>
    </v-card>
  </div>
</template>

<script>
import BodyTalkLogo from "../../assets/SvgIcons/BodyTalkLogo.vue";
export default {
  name: "SendConfirmComponent",
  components: { BodyTalkLogo },
  props:["confrimsurvey"],
  methods:{
    close(){
      this.$emit("close")
    }
  }
};
</script>

<style scoped>
.font-24 {
  font-size: 24px;
}
.font-14 {
  font-size: 14px;
}
.grey {
  color: rgba(34, 34, 34, 0.7);
}
</style>
